var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 8.479v11.52a1 1 0 1 1-2 0V11.75l-7.4 3.536a5 5 0 0 1-2.577.694 5.271 5.271 0 0 1-2.7-.74l-7.38-3.512a3.69 3.69 0 0 1 0-6.5L9.4 1.67a5.226 5.226 0 0 1 5.282.045l7.375 3.513A3.767 3.767 0 0 1 24 8.479zm-11.978 9.5a7.26 7.26 0 0 1-3.645-.972L4 14.917v2.7a5.007 5.007 0 0 0 3.519 4.779c1.456.418 2.966.621 4.48.603a15.556 15.556 0 0 0 4.482-.607A5.007 5.007 0 0 0 20 17.614v-2.691l-4.46 2.13a6.983 6.983 0 0 1-3.518.928v-.002z",
    fill: "#5E6175"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.a5a980d80624998dec255cbfe6fcace5.svg";
export { ForwardRef as ReactComponent };